exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".retry-box[data-v-e6bb1d06] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin: 3rem 0;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/apps/client/common/src/components/RetryFailed.vue"],"names":[],"mappings":"AACA;EACI,cAAa;EACb,wBAAuB;EACvB,oBAAmB;EACnB,uBAAsB;EACtB,eAAc;CAAA","file":"RetryFailed.vue?vue&type=style&index=0&id=e6bb1d06&scoped=true&lang=css&","sourcesContent":["\n.retry-box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin: 3rem 0;\n}\n"],"sourceRoot":""}]);

// exports
